// 如果在模块化构建系统中，请确保在开头调用了 Vue.use(Vuex)
import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'

Vue.use(Vuex)
Vue.use(Router)

const store = new Vuex.Store({
  state: {
    count: 1,
    routers: []
  },
  getters: {

  },
  mutations: {
    addmu (state) { state.count++ },
    lessmu (state) { state.count-- },
    setrouter (state, routerData) {
      state.routers = routerData
      // console.log('router:', state.router)
    }
  },
  actions: {

  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js